
const styles = {
    p:{border:'1px solid gray', width:'380px', backgroundColor:'#ddd'},
    div:{border:'1px solid gray', width:'380px', padding:'0 20px', margin:'10px 0',backgroundColor:'#ddd'},
    li:{padding:'6px 0'},
    title1:{ fontSize:'16px', fontWeight: '900' },
    title2:{ color:'red', fontSize:'14px' },
}


export const patrocinadorAccountsInfo = (ref) => {
    return (
    <>
        <div>
            { generalAccountsInfo() }
            {/* <ul>
                <li>Indicar como concepto el numero de referencia: <strong>{ concepto }</strong></li>
                <li>Pagar en sucursal bancaria la cuota correspondiente o,</li>
                <li>Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,</li>
                { localPF() }
            </ul> */}
            <p style={ styles.title1 }>* Para personas físicas:</p>
            <p style={ styles.title2 }>Información para transferencias bancarias</p>
            { localPF(ref) }
            <p style={ styles.title2 }>For international wire transfers</p>
            { internacionalPF(ref) }
            <p style={ styles.title1 }>* Información para transferencias bancarias en caso de facturarse a una empresa moral</p>
            { localPM(ref) }
            <p style={ styles.title1 }>* En caso de ser persona moral a quien se le va a facturar:</p>
            { internacionalPM(ref) }
        </div>
    </>
    )
}


export const participanteAccountsInfo = (ref) => {
    return (
    <>
        <div>
            { generalAccountsInfo() }
            {/* <ul>
                <li>Indicar como concepto el numero de referencia: <strong>{ concepto }</strong></li>
                <li>Pagar en sucursal bancaria la cuota correspondiente o,</li>
                <li>Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,</li>
                { localPF() }
            </ul> */}
            <p style={ styles.title1 }>* Para personas físicas:</p>
            <p style={ styles.title2 }>Información para transferencias bancarias</p>
            { localPF(ref) }
            <p style={ styles.title2 }>For international wire transfers</p>
            { internacionalPF(ref) }
        </div>
    </>
    )
}


export const generalAccountsInfo = () => {
    return (
        <>
            <div>
                <p style={ styles.title1 }>Indicaciones para completar el registro</p>
                <ol>
                    <li>Subir su comprobante de pago en el enlace incluido al pie de este mensaje.</li>
                    {/* <li>Después de realizar el pago cuenta con un máximo de 5 días hábiles para
                    completar su registro, en caso contrario éste será anulado.</li> */}
                    <li>En caso de solicitar factura, ésta se enviará al correo que se ingresó.</li>
                    <li>Se realizará la facturación salvo buen cobro.</li>
                </ol>
            </div>
        </>
    )
}

export const localPF = (ref) => {

    return (
        <div>
            <ul>
                <li>Pagar en sucursal bancaria la cuota correspondiente o,</li>
                <li>Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,</li>
                <ul>
                    <li>Nombre: <strong>Asociación de Especialistas en Nutrición Acuícola A.C.</strong></li>
                    <li>Banco: <strong>SCOTIABANK</strong></li>
                    <li>Cuenta: <strong>25600964391</strong></li>
                    <li>CLABE: <strong>044790256009643915</strong></li>
                    <li>Concepto: <strong>{ ref }</strong></li>
                </ul>
            </ul>
        </div>
    )
}

export const internacionalPF = (ref) => {
    return (
        <>
            <ul>
                <li>Bank: <strong>SCOTIABANK</strong></li>
                <li>Account: <strong>25600964391</strong></li>
                <li>Name: <strong>Asociación de Especialistas en Nutrición Acuícola A.C.</strong></li>
                <li>Address: <strong>Lorenzo Boturini 202, Col. Transito, CP 06820, CDMX, Mexico</strong></li>
                <li>SWIFT CODE: <strong>MBCOMXMM</strong></li>
                <li>Concept: <strong>{ ref }</strong></li>
            </ul>
        </>
    )
}

export const localPM = (ref) => {

    return (
        <div>
            <ul>
                <li>Pagar en sucursal bancaria la cuota correspondiente o,</li>
                <li>Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,</li>
                <ul>
                    <li>Banco: <strong>BBVA</strong></li>
                    <li>Cuenta: <strong>0163600017</strong></li>
                    <li>CLABE: <strong>012680001636000179</strong></li>
                    <li>Concepto: <strong>{ ref }</strong></li>
                </ul>
            </ul>
        </div>
    )
}

export const internacionalPM = (ref) => {
    return (
        <>
            <img src={ "https://eventos.cibnor.mx/img/sina2025-inf_pago.jpg" } alt="bank-info" width={ '100%' } />
        </>
    )
}
